import React from "react";
import { getClassName } from "@utils";
import css from "./Toggler.module.scss";

export enum TogglerSize {
  S = "S",
  M = "M",
}

export interface TogglerProps {
  label: string;
  checked?: boolean;
  className?: string;
  disabled?: boolean;
  isHorizontal?: boolean;
  size?: TogglerSize;
  onChange?: (checked: boolean) => void;
}

const Toggler: React.FC<TogglerProps> = ({
  label,
  checked = false,
  className,
  disabled = false,
  isHorizontal = false,
  size = TogglerSize.M,
  onChange,
}) => {
  const attrs = {
    container: {
      className: getClassName(
        css.container,
        css[`container${size}`],
        isHorizontal && css.containerHorizontal,
        className
      ),
    },
    text: {
      className: css.text,
    },
    input: {
      checked,
      disabled,
      className: css.input,
      type: "checkbox",
      onChange: () => {
        if (!disabled && onChange) {
          onChange(!checked);
        }
      },
    },
  };

  return (
    <label {...attrs.container}>
      <span {...attrs.text}>{label}</span>
      <input {...attrs.input} />
    </label>
  );
};

export default Toggler;
